import React, { useState, useEffect } from "react";
import { apiService } from "../../../components/Config/api.service";
import { notify } from "../../../components/Utils/Notifications";

const LeaveDeparture = ({ setActiveTab, employee, currentContract, leaveDepartureId, refreshRecap, handleDeleteLeaveDeparture }) => {
  const [dateDepart, setDateDepart] = useState("");
  const [dateRetour, setDateRetour] = useState("");
  const [leaveData, setLeaveData] = useState(null);
  const isDraft = leaveData?.state === "draft" || !leaveData;
  useEffect(() => {
    if (leaveDepartureId) {
      apiService.getElementById("/leave_departure", leaveDepartureId)
        .then(res => {
          const data = res.data.leave_departure;
          setLeaveData(data);
          setDateDepart(data.date_depart || "");
          setDateRetour(data.date_retour || "");
        })
        .catch(() => setLeaveData(null));
    } else {
      setLeaveData(null);
      setDateDepart("");
      setDateRetour("");
    }
  }, [leaveDepartureId]);

  const handleLeaveDeparture = (action = "validate") => async (e) => {
    e.preventDefault();
    if (!dateDepart || !dateRetour) return notify("Veuillez renseigner les dates.", "", 3);

    const payload = {
      employee_id: employee.id,
      contract_id: currentContract.id,
      date_depart: dateDepart,
      date_retour: dateRetour,
      action,
      leave_id: leaveData?.id,
    };

    try {
      const response = await apiService.saveElement("/leave_departure", payload);
      setLeaveData(response.data.leave_departure);
      console.log("Leave Departure Data:", response.data.leave_departure);
      action === "validate"
        ? notify("Départ en congé validé", "", 2)
        : action === "draft"
        ? notify("Départ en congé remis en brouillon", "", 2)
        : notify("Départ en congé sauvegardé", "", 2);
      setActiveTab && refreshRecap();
    } catch (err) {
      notify("Erreur lors de l'enregistrement du départ en congé", "", 3);
    }
  };

  return (
    <div className="bg-white min-h-screen p-6 md:p-10">
      <h2 className="text-3xl font-bold mb-8 text-green-600 flex justify-between items-center">
        Départ en congé
        <span className={leaveData?.state === "validated" ? "badge text-[var(--color-primary)]" : "badge text-[var(--color-orange)]"}>
          {leaveData?.state === "validated" ? "Validé" : "Brouillon"}
        </span>
      </h2>
      <div className="max-w-3xl mx-auto grid grid-cols-1 gap-8">
        <div>
          <label className="block mb-1 font-medium">Date de départ</label>
          <input
            type="date"
            className="input input-bordered w-full"
            value={dateDepart}
            onChange={e => setDateDepart(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-1 font-medium">Date de retour</label>
          <input
            type="date"
            className="input input-bordered w-full"
            value={dateRetour}
            onChange={e => setDateRetour(e.target.value)}
          />
        </div>
        {leaveData && leaveData.company_gestion_type !== "paid_leave_no_ic" && (
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8 bg-gray-50 rounded-lg p-4">
          <span className="font-bold text-xl">Indemnité congés</span>
          <span className="font-bold text-2xl text-[--color-primary]">
            {leaveData?.indemnite_conge_amount?.toLocaleString("fr-FR") || 0} FCFA
          </span>
        </div>
        )}
        {leaveData && leaveData.company_gestion_type === "paid_leave_with_ic" && (
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-8 bg-gray-50 rounded-lg p-4">
          <span className="font-bold text-xl">Montant régularisation</span>
          <span className="font-bold text-2xl text-[--color-primary]">
            {leaveData?.regule_amount?.toLocaleString("fr-FR") || 0} FCFA
          </span>
        </div>
        )}
        <div className="flex justify-end gap-4 mt-8">
          {!isDraft ? (
            <>
              <button
                type="button"
                className="btn btn-outline text-[--color-primary] hover:bg-[--color-primary]"
                onClick={handleLeaveDeparture("draft")}
              >
                Remettre en brouillon
              </button>
              <button
                type="button"
                onClick={() => setActiveTab("Contrats")}
                className="btn btn-outline btn-error"
              >
                Retour
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-outline text-[--color-primary] hover:bg-[--color-primary]"
                onClick={handleLeaveDeparture("save")}
              >
                Sauvegarder
              </button>
              <button
                onClick={handleLeaveDeparture("validate")}
                type="submit"
                className="btn bg-[--color-primary] text-white hover:bg-[--bg-hover]"
              >
                Valider
              </button>
              <button
                type="button"
                onClick={leaveDepartureId ? handleDeleteLeaveDeparture : () => setActiveTab("Contrats")}
                className="btn btn-outline btn-error"
              >
                Supprimer
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaveDeparture;